import { time } from "highcharts";

export function dateElapsed(sdate, edate) {
  const sYear = sdate.substr(0,4);
  const sMonth = sdate.substr(4,1) === 0 ? sdate.substr(5,1) : sdate.substr(4,2);
  const sDay = sdate.substr(6,1) === 0 ? sdate.substr(7,1) : sdate.substr(6,2);
  const sTime = sdate.substr(-8);

  const eYear = edate.substr(0,4);
  const eMonth = edate.substr(4,1) === 0 ? edate.substr(5,1) : edate.substr(4,2);
  const eDay = edate.substr(6,1) === 0 ? edate.substr(7,1) : edate.substr(6,2);

  const elapsed = new Date(eYear, Number(eMonth)+1, eDay) - new Date(sYear, Number(sMonth)+1, sDay);
  const newSdate = (new Date( new Date().getTime() - elapsed )).toISOString().slice(0, 10);
  const newSdateNoHyphen = newSdate.substr(0,4) + newSdate.substr(5,2) + newSdate.substr(8,2) + ' ' + sTime;

  return newSdateNoHyphen;
}

export function getCurrentDate(edate) {
  const eTime = edate.substr(-8);

  const today = new Date();
  const year = today.getFullYear();
  const yyyy = year.toString();
  const month = (today.getMonth()+1<10 ? '0' : '')+(today.getMonth()+1);
  const mm = month.toString();
  const day = (today.getDate()<10 ? '0' : '')+today.getDate();
  const dd = day.toString();
  const currentDate = yyyy + mm + dd + ' ' + eTime;

  return currentDate;
}

function timestampConverter(date) {
  const tw_GMT_time_gap = 8*60*60*1000
  let datetime = new Date(Number(date.substring(0,4)),Number(date.substring(4,6))-1,Number(date.substring(6,8))).getTime()+tw_GMT_time_gap
  return datetime
}

export function getRangeDateList(sdate,edate){
  const timestamp_Day =24*60*60*1000
  const end = timestampConverter(edate)
  let nowDate = timestampConverter(sdate)
  let timeList = []

  while(nowDate < end){
      timeList.push(nowDate)
      nowDate = timestamp_Day + nowDate
      
  }
  return timeList
}

export function timestampTOstringDate(date){
  let year = new Date(date).getFullYear()
  let month = new Date(date).getMonth()+1 > 9 ? new Date(date).getMonth()+1 : '0' + (new Date(date).getMonth()+1)
  let day = new Date(date).getDate()
  return year+'-'+month+'-'+day
}
// get the list of dates between start date and end date

export function getRangeDates(startDate, endDate) {
  const sDate = new Date(startDate.substr(0, 10));
  const eDate = new Date(endDate.substr(0, 10));

  Date.prototype.addDays = function(days) {
      var dat = new Date(this.valueOf())
      dat.setDate(dat.getDate() + days);
      return dat;
  }

  const diff = Math.floor(( Date.parse(eDate) - Date.parse(sDate) ) / 86400000);

  const addNum = (diffDates) => {
    // cal how much gap we shoud add to the topic path chart
    if (diffDates < 11) {
      return 1;
    } else if (diffDates < 32) {
      return 3;
    } else if (diffDates < 100) {
      return 10;
    } else {
      return 30;
    }
  };

  function getDates(startDate, endDate, gapDate) {
     var dateArray = new Array();
     var currentDate = startDate;
     while (currentDate <= endDate) {

       const year = currentDate.getFullYear();
       const yyyy = year.toString();
       const month = (currentDate.getMonth()+1<10 ? '0' : '')+(currentDate.getMonth()+1);
       const mm = month.toString();
       const day = (currentDate.getDate()<10 ? '0' : '')+currentDate.getDate();
       const dd = day.toString();

       const currentDateString = yyyy + mm + dd;

       dateArray.push(currentDateString);
       currentDate = currentDate.addDays(gapDate);
     }
     return dateArray;
   }


   var result = getDates(sDate, eDate, addNum(diff));
   var resultChain = result.map((date, i) => {
     if (diff < 11) {
       return {sdate: result[i], edate: result[i]};
     } else {
       if (i < result.length-1) {
         return { sdate: result[i], edate: result[i+1]};
       } else {
         return {sdate: result[i], edate: result[i]};
       }
     }
   });

   return resultChain;
}
// ==============================================================================================================//
export function weekToDate(yearWeek){
  // 一年的第一個禮拜一是第一週
  let y = Number(yearWeek.substring(0,4)),
      w = Number(yearWeek.substring(4,6))

  let firstDay = new Date(y,0,1).getDay() === 0 ? 7 : new Date(y,0,1).getDay()

  let gapFromMonday = 1+(7-firstDay)

  let firstMonday = new Date(y,0,1+gapFromMonday)

  let timeZoneDiff = Math.abs(new Date(y,0,1).getTimezoneOffset())/60
  // to toISOString 是以 utc + 0 轉換 而台灣是 utc+8 所以要沒是有誤差要補 8 小時
  let firstDateInThisWeek = new Date(y,0,((w-1)*7)+firstMonday.getDate(),timeZoneDiff).toISOString().slice(0, 10)

  if(Number(firstDateInThisWeek.substring(0,4)) !== y){
    // todo 如果超出年份 => 代表是該年最後一週 => 後端會計算到 12/31 所以該筆週數紀錄會是重複的
    const week = w-1
    firstDateInThisWeek = new Date(y,0,((week-1)*7)+firstMonday.getDate(),timeZoneDiff).toISOString().slice(0, 10)
  }
  
  return firstDateInThisWeek
}
// ==============================================================================================================//

export function toWeekStart(day){
  let y =day.substring(0,4)
  let m = day.substring(4,6)
  let d = day.substring(6,8)

  let thisDay = new Date(y,m-1,d)
  let param = ( thisDay.getDay()===0 ?7:thisDay.getDay() )-1
  let thisWeekStart = Date.UTC(y,m-1,d-param)
  return thisWeekStart
}

export function secondToDate (s, type,timeunit) {
  // UTC second to yyyymmdd
  // if(timeunit==='glbtime_WEEKNUM'){
  //   return s.split('~')[0]
  // }
  // else{
    const timestamp = new Date(s).toISOString();
    if (type==='arr') {
      return [ Number(timestamp.substr(0, 4)), Number(timestamp.substr(5, 2))-1, Number(timestamp.substr(8, 2))];
    }
    return timestamp.substr(0, 4) + '-' + timestamp.substr(5, 2) + '-' + timestamp.substr(8, 2);
  // }
}

export function getWeekSE(day,s,e,timeunit,chartType){
  const y = parseInt(day.substring(0,4))
  const m = parseInt(day.substring(5,7))
  const d = parseInt(day.substring(8,10))

  let date = day.substring(0,4)+day.substring(5,7)+day.substring(8,10)
  let weekday = new Date(y,m-1,d).getDay()
  let sd =''
  let ed =''

  if(date === s.substring(0,8) && weekday !==1 ){
    // 如果是第一周 且不為禮拜一的話 => 依據是禮拜幾來決定+n到週日
    let gap = 7-weekday === 7 ? 0 : 7-weekday
    sd =new Date(y,m-1,d)
    ed =new Date(y,m-1,d+gap)
  }else if(date === e.substring(0,8) && weekday !== 0){
    // 如果是最後一周 且不為禮拜日的話 => 依據是禮拜幾來決定-n回到週一
    let gap = weekday-1 
    sd =new Date(y,m-1,d-gap)
    ed =new Date(y,m-1,d)
  }else{
    // 完整的一個禮拜 => 直接+6拿到週日
    sd =new Date(y,m-1,d)
    ed =new Date(y,m-1,d+6)
  }

  let sDate = sd.getFullYear()+''+((sd.getMonth()+1<10 ? '0' : '')+(sd.getMonth()+1))+''+((sd.getDate()<10 ? '0' : '')+sd.getDate())+' 00:00:00'
  let eDate = ed.getFullYear()+''+((ed.getMonth()+1<10 ? '0' : '')+(ed.getMonth()+1))+''+((ed.getDate()<10 ? '0' : '')+ed.getDate())+' 23:59:59'

  if(chartType === 'column'&& timeunit ==='glbtime_WEEKNUM' ){
    let eday = e.substring(0,8)
    let utcDay = Date.UTC(eday.substring(0,4),eday.substring(4,6),eday.substring(6,8))
    let currDay = Date.UTC(date.substring(0,4),date.substring(4,6),date.substring(6,8))
    let weekTick = 1000*60*60*24*7
    let timediff = utcDay-currDay
    // 判別是否在最後一周
    if(timediff<weekTick){
    // 因應 column 在周線的異常調整 20201209
    eDate=e
    }
  }

  let SE= {
    sDate,
    eDate
  }

  return SE
}

export function getMonthSE(day,s,e){
  const y = (day.substring(0,4))
  const m = (day.substring(5,7))
  let month = y+m
  let sm = ''
  let em = ''

  if(month === s.substring(0,6)){
    sm=new Date(y,m-1,s.substring(6,8))
    em=new Date(y,m,0)
  }
  else if(month === e.substring(0,6)){
    sm=new Date(y,m-1,1)
    em=new Date(y,m-1,e.substring(6,8))
  }else{
    sm=new Date(y,m-1,1)
    em=new Date(y,m,0)
  }

  let sDate = sm.getFullYear()+''+((sm.getMonth()+1<10 ? '0' : '')+(sm.getMonth()+1))+''+((sm.getDate()<10 ? '0' : '')+sm.getDate())+' 00:00:00'
  let eDate = em.getFullYear()+''+((em.getMonth()+1<10 ? '0' : '')+(em.getMonth()+1))+''+((em.getDate()<10 ? '0' : '')+em.getDate())+' 23:59:59'

  let SE= {
    sDate,
    eDate
  }
  
  return SE
}



// WEBPACK FOOTER //
// ./src/helpers/calDate.js